export function formatClientDisplayName(client) {
  if (client == null || typeof client !== 'object') return ''

  const name = String(client.name || client.attributes?.name || '').trim()
  const corporateName = String(client.corporateName || client.attributes?.corporateName || '').trim()

  if (name && corporateName) return `${name}(${corporateName})`
  return name || corporateName
}
